const state = {
  cardState: {
    1: "未激活",
    2: "正常",
    3: "停机",
    4: "销户",
  },
  operatoricons: {
    telecom: "icon-zhongguodianxin",
    unicom: "icon-zhongguoliantong-",
    mobile: "icon-chinamobile-s",
    guangdian: "icon-cbn",
  },
}
const mutations = {

}
const actions = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/card.js